import angular from 'angular';

export const containersModule = angular.module(
  'portainer.docker.react.components.containers',
  []
).name;
